export default __webpack_public_path__ + "static/media/img2.679b6094.png";